import React from 'react';
import { Route } from 'react-router-dom';
import MarkAttendance from '@/pages/attendance/MarkAttendance';
import MarkAttendanceClasswise from '@/pages/attendance/MarkAttendanceClasswise';
import AttendanceReport from '@/pages/attendance/AttendanceReport';
import AttendanceReportPercentage from '@/pages/attendance/AttendanceReportPercentage';
import FineReport from '@/pages/attendance/FineReport';
import FineCollectionReport from '@/pages/attendance/FineCollectionReport';
import AttendanceClearance from '@/pages/attendance/AttendanceClearance';
import PayAttendanceFine from '@/pages/attendance/PayAttendanceFine';

export const attendanceRoutes = (
  <React.Fragment>
    <Route path="attendance/mark" element={<MarkAttendance />} />
    <Route path="attendance/mark-classwise" element={<MarkAttendanceClasswise />} />
    <Route path="attendance/report" element={<AttendanceReport />} />
    <Route path="attendance/report-percentage" element={<AttendanceReportPercentage />} />
    <Route path="attendance/pay-fine" element={<PayAttendanceFine />} />
    <Route path="attendance/fine-report" element={<FineReport />} />
    <Route path="attendance/fine-collection" element={<FineCollectionReport />} />
    <Route path="attendance/clearance" element={<AttendanceClearance />} />
  </React.Fragment>
);
